export default __webpack_public_path__ + "static/media/Email_qr_icon_disabled.e98b9024.svg";